<template>
  <div class="page">
       <el-dialog
        :title="title"
        :visible.sync="drawerVisible"
        direction="rtl"
        :before-close="handleClose"
         width="50%"
         height="600px"
        >
        <el-form
            :model="{...storeForm,...orgForm}"
            ref="form"
            label-width="120px"
            :inline="true"
            size="small"
            class="query-form"
            :rules="rulesForm"
            @submit.native.
            v-loading="loading"
        >
         <el-tabs  type="border-card">
            <el-tab-pane label="工商信息" >
               <el-form-item label="组织类型" prop="orgType"  :label-width="DLabelwidth">
                        <el-select v-model="orgForm.orgType" placeholder="请选择组织类型" :disabled="disabled">
                             <el-option
                                v-for="item in orgTypeList"
                                :key="item.id"
                                :label="item.label"
                                :value="item.value"
                                @click="orgTypeChange(item)"
                            ></el-option>
                        </el-select>
               </el-form-item>
               <el-form-item label="mcc编码" prop="mccCodeName" :label-width="DLabelwidth">
                          <el-input
                              size="small"
                              style="width: 200px"
                              v-model="orgForm.mccCodeName"
                              :disabled="disabled"
                          >
                              <el-button @click="getMccCode()" slot="append" icon="el-icon-search"></el-button>
                          </el-input>
               </el-form-item>
               <el-form-item label="详细地址" prop="storeAddress"  :label-width="DLabelwidth">
                        <el-input v-model="storeForm.storeAddress" placeholder="请输入详细地址" :disabled="disabled"></el-input>
               </el-form-item>
                <!-- 省市区 -->
                <el-form-item label="开户所在省份" :label-width="DLabelwidth" prop="bankProvinceId">
                <el-select @change="handleProvinceChangeYh" style="width: 200px;" v-model="orgForm.bankProvinceId" placeholder="请选择省份" :disabled="disabled">
                        <el-option
                            v-for="item in bankProvinceIdList"
                             :key='item.id'
                            :label='item.name'
                            :value='item.id'>
                        </el-option>
                    </el-select> 
                </el-form-item>
                <el-form-item label="开户所在城市" :label-width="DLabelwidth" prop="bankCityId">
                    <el-select @change="handleCityChangeYh" v-model="orgForm.bankCityId" placeholder="请选择城市" :disabled="disabled">
                        <el-option
                            v-for="item in bankCityIdList"
                             :key='item.id'
                            :label='item.name'
                            :value='item.id'>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开户所在区" :label-width="DLabelwidth" prop="bankAreaId">
                    <el-select v-model="orgForm.bankAreaId" placeholder="请选择区县" :disabled="disabled">
                        <el-option
                            v-for="item in  bankAreaIdList"
                             :key='item.id'
                        :label='item.name'
                        :value='item.id'>
                        </el-option>
                    </el-select>
                </el-form-item>
         
                <el-form-item label="营业执照名称" prop="licenseName" :label-width="DLabelwidth" >
                       <template >
                        <el-input width="300px" v-model="orgForm.licenseName" placeholder="请输入营业执照名称" :disabled="disabled"></el-input>
                       </template>
                </el-form-item>
               <el-form-item label="营业执照省份" :label-width="DLabelwidth" prop="licenseProvinceId">
                <el-select @change="handlelicenseProvinceIdChange" style="width: 200px;" v-model="orgForm.licenseProvinceId" placeholder="请选择省份" :disabled="disabled">
                        <el-option
                            v-for="item in licenseProvinceIdList"
                              :key='item.id'
                        :label='item.name'
                        :value='item.id'>
                        </el-option>
                    </el-select> 
                </el-form-item>
                <el-form-item label="营业执照城市" :label-width="DLabelwidth" prop="licenseCityId">
                    <el-select @change="handlelicenseCityChange" v-model="orgForm.licenseCityId" placeholder="请选择城市" :disabled="disabled">
                        <el-option
                            v-for="item in licenseCityIdList"
                              :key='item.id'
                        :label='item.name'
                        :value='item.id'>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="营业执照区" :label-width="DLabelwidth" prop="licenseAreaId">
                    <el-select v-model="orgForm.licenseAreaId" placeholder="请选择区县" :disabled="disabled">
                        <el-option
                            v-for="item in  licenseAreaIdList"
                                  :key='item.id'
                                  :label='item.name'
                                  :value='item.id'>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  label="营业执照注册地址"   prop="licenseAddress" :label-width="DLabelwidth" >
                  <el-input  v-model="orgForm.licenseAddress" placeholder="请输入营业执照注册地址" :disabled="disabled"></el-input>
                 </el-form-item>
                <el-form-item label="统一社会信用代码"   prop="licenseNumber" :label-width="DLabelwidth" >
                  <el-input v-model="orgForm.licenseNumber" placeholder="请输入社会信用代码" :disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item  label="执照有效开始日期"   prop="licenseStartTime" :label-width="DLabelwidth">
                      <div style="width: 200px;display: flex;align-items: center; margin-right: 70px;">
                        <el-date-picker
                            v-model="orgForm.licenseStartTime"
                            type="date"
                            placeholder="选择日期"
                            :disabled="disabled"
                            size="small"
                             value-format="yyyy-MM-dd"
                        ></el-date-picker>
                        <el-checkbox style="margin-left: 10px" :true-label="1" :false-label="0" v-model="orgForm.licenseIsPermanent" label="长期"></el-checkbox>
                      </div>
                 </el-form-item>
                 <el-form-item  label="执照有效结束日期"  v-if="orgForm.licenseIsPermanent == 0"   prop="licenseEndTime" :label-width="DLabelwidth">
                        <el-date-picker
                            v-model="orgForm.licenseEndTime"
                            type="date"
                            placeholder="选择日期"
                            :disabled="disabled"
                            size="small"
                             value-format="yyyy-MM-dd"
                        ></el-date-picker>
                </el-form-item>
                <el-form-item label="经营范围" :label-width="DLabelwidth"   prop="licenseRange">
                            <el-input
                                size="small"
                                type="textarea"
                                :rows="8"
                                style="width: 200px"
                                v-model="orgForm.licenseRange"
                                :disabled="disabled"
                            ></el-input>
                </el-form-item>
                <el-form-item label="营业执照" :label-width="DLabelwidth"  prop="productPic">
                  <template>
                  <el-upload style="width: 200px" class="avatar-uploader" action="" :show-file-list="false" :http-request="createBusinessLicenseHandler(4)" :disabled="disabled" >
                      <img v-if="orgForm.licensePic" :src="orgForm.licensePic" class="avatar" size="small" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                    <el-button v-if="orgForm.licensePic" type="primary" @click="handlePictureCardPreview(orgForm.licensePic)" size="small">查看</el-button>
                  </template>
                 </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="法人信息">
                 <el-form-item label="法人姓名" :label-width="DLabelwidth"  prop="personName"  >
                        <el-input v-model="orgForm.personName" placeholder="请输入法人姓名" :disabled="disabled">
                        </el-input>  
                    </el-form-item>  
                    <el-form-item label="法人手机号" :label-width="DLabelwidth"  prop="personMobile"  >
                        <el-input v-model="orgForm.personMobile" placeholder="请输入法人手机号" :disabled="disabled"></el-input>
                    </el-form-item>
                    <el-form-item label="法人邮箱" :label-width="DLabelwidth"  prop="personEmail"  >
                        <el-input  v-model="orgForm.personEmail" placeholder="请输入法人邮箱" :disabled="disabled"></el-input>
                    </el-form-item>
                    <el-form-item label="法人身份证号" :label-width="DLabelwidth"  prop="idCard"  >
                        <el-input v-model="orgForm.idCard" placeholder="请输入法人身份证号" :disabled="disabled"></el-input>
                    </el-form-item> 
                    <el-form-item label="身份证件有效期起始" :label-width="DLabelwidth"  prop="idCardStartTime">
                         <div  style="width: 200px;display: flex;align-items: center; margin-right: 70px;">
                                <el-date-picker
                                    v-model="orgForm.idCardStartTime"
                                    type="date"
                                    placeholder="选择日期"
                                    :disabled="disabled"
                                    size="small"
                                    value-format="yyyy-MM-dd"
                                ></el-date-picker>
                                 <el-checkbox style="margin-left: 10px" :true-label="1" :false-label="0" v-model="orgForm.idCardIsPermanent" label="长期"></el-checkbox>
                         </div>
                    </el-form-item>
                    <el-form-item label="身份证件有效期结束" v-if="orgForm.idCardIsPermanent == 0" :label-width="DLabelwidth"  prop="idCardEndTime"> 
                        <el-date-picker
                            v-model="orgForm.idCardEndTime"
                            type="date"
                            placeholder="选择日期"
                            :disabled="disabled"
                            size="small"
                             value-format="yyyy-MM-dd"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="身份证正照片" :label-width="DLabelwidth"  prop="productPic">
                      <template>
                        <el-upload style="width: 200px" class="avatar-uploader" action="" :show-file-list="false" :http-request="createBusinessLicenseHandler(5)" :disabled="disabled" >
                            <img v-if="orgForm.idCardFacade" :src="orgForm.idCardFacade" class="avatar" size="small" />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                         <el-button v-if="orgForm.idCardFacade" type="primary" @click="handlePictureCardPreview(orgForm.idCardFacade)" size="small">查看</el-button>
                        </template>
                    </el-form-item>
                    <el-form-item label="身份证反照片" :label-width="DLabelwidth"  prop="productPic">
                        <template slot-scope="scop">
                        <el-upload style="width: 200px" class="avatar-uploader" action="" :show-file-list="false" :http-request="createBusinessLicenseHandler(6)" :disabled="disabled" >
                            <img v-if="orgForm.idCardBack" :src="orgForm.idCardBack" class="avatar" size="small" />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <el-button v-if="orgForm.idCardBack" type="primary" @click="handlePictureCardPreview(orgForm.idCardBack)" size="small">查看</el-button>
                        </template>
                    </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="银行信息">
                <el-form-item label="银行户主" prop="bankHolder" :label-width="DLabelwidth">
                <el-input v-model="orgForm.bankHolder" placeholder="请输入银行户主" :disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="银行账户号" prop="bankAccount" :label-width="DLabelwidth" >
                    <el-input v-model="orgForm.bankAccount" placeholder="请输入银行账户号" :disabled="disabled"></el-input>
                </el-form-item>
           
                <el-form-item label="银行户主手机号" prop="bankMobile" :label-width="DLabelwidth">
                    <el-input v-model="orgForm.bankMobile" placeholder="请输入银行户主手机号"   :disabled="disabled"></el-input>
                </el-form-item>
                 <el-form-item label="银行名称" prop="bankName" :label-width="DLabelwidth">
                      <el-input
                          size="small"
                          style="width: 200px"
                          v-model="orgForm.bankName"
                          :disabled="disabled"
                      >
                          <!-- <el-button @click="getBank()" slot="append" icon="el-icon-search"></el-button> -->
                      </el-input>
                </el-form-item>
                 <el-form-item label="开户支行名称" prop="bankSubbranch" :label-width="DLabelwidth">
                      <el-input
                          size="small"
                          style="width: 200px"
                          v-model="orgForm.bankSubbranch"
                          :disabled="disabled"
                          placeholder="请输入开户支行名称"
                      >
                          <el-button @click="getSubbranch()" slot="append" icon="el-icon-search"></el-button>
                      </el-input>
                </el-form-item>
               
                <el-form-item label="银行卡正面照" :label-width="DLabelwidth" prop="productPic">
                  <template slot-scope="scop">
                    <el-upload style="width: 200px" class="avatar-uploader" action="" :show-file-list="false" :http-request="createBusinessLicenseHandler(7)" :disabled="disabled" >
                        <img v-if="orgForm.bankCardFacade" :src="orgForm.bankCardFacade" class="avatar" size="small" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                      <el-button v-if="orgForm.bankCardFacade" @click="handlePictureCardPreview(orgForm.bankCardFacade)" type="primary">查看</el-button> 
                    </template>
                </el-form-item>
                <el-form-item label="银行卡正面照" :label-width="DLabelwidth" prop="productPic">
                  <template slot-scope="scop">
                    <el-upload style="width: 200px" class="avatar-uploader" action="" :show-file-list="false" :http-request="createBusinessLicenseHandler(8)" :disabled="disabled" >
                        <img v-if="orgForm.bankCardBack" :src="orgForm.bankCardBack" class="avatar" size="small" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                      <el-button v-if="orgForm.bankCardBack" @click="handlePictureCardPreview(orgForm.bankCardBack)" type="primary">查看</el-button> 
                   </template>
                </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="认证信息" > 
                              <el-form-item label="支付宝申请二维码" :label-width="DLabelwidth" prop="alipayApplyQrcode">
                      <template slot-scope="scop">
                        <img v-if="orgForm.alipayApplyQrcode" :src="orgForm.alipayApplyQrcode" class="avatar"  size="small"  />
                        <img v-else  :src="orgForm.alipayApplyQrcode" class="avatar" size="small"></img>
                        <el-button v-if="orgForm.alipayApplyQrcode" @click="handlePictureCardPreview(orgForm.alipayApplyQrcode)" type="primary">查看</el-button> 
                      </template>
                 </el-form-item>
                 <el-form-item label="微信申请二维码" :label-width="DLabelwidth" prop="wxpayApplyQrcode">
                       <template slot-scope="scop">
                        <img v-if="orgForm.wxpayApplyQrcode" :src="orgForm.wxpayApplyQrcode" class="avatar" size="small" />
                        <img v-else :src="orgForm.wxpayApplyQrcode" class="avatar" size="small"></img>
                         <el-button v-if="orgForm.wxpayApplyQrcode" @click="handlePictureCardPreview(orgForm.wxpayApplyQrcode)" type="primary">查看</el-button> 
                        </template>
                 </el-form-item>
                 <el-form-item label="支付宝法人确认二维码" :label-width="DLabelwidth" prop="alipayConfirmQrcode">
                      <template slot-scope="scop">
                        <img v-if="orgForm.alipayConfirmQrcode" :src="orgForm.alipayConfirmQrcode" class="avatar" size="small" />
                        <img v-else :src="orgForm.alipayConfirmQrcode" class="avatar" size="small"></img>
                        <el-button v-if="orgForm.alipayConfirmQrcode" @click="handlePictureCardPreview(orgForm.alipayConfirmQrcode)" type="primary">查看</el-button> 
                        </template>
                 </el-form-item>
                 <el-form-item label="微信法人确认二维码" :label-width="DLabelwidth" prop="wxpayConfirmQrcode">
                      <template slot-scope="scop">
                        <img v-if="orgForm.wxpayConfirmQrcode" :src="orgForm.wxpayConfirmQrcode" class="avatar" size="small" />
                        <img v-else :src="orgForm.wxpayConfirmQrcode" class="avatar" size="small"></img>
                         <el-button v-if="orgForm.wxpayConfirmQrcode" @click="handlePictureCardPreview(orgForm.wxpayConfirmQrcode)" type="primary">查看</el-button> 
                      </template>
                 </el-form-item>
                
                  <el-form-item label="客户电话" :label-width="DLabelwidth" prop="servicePhone">
                        <el-input v-model="orgForm.servicePhone" placeholder="请输入客服电话" :disabled="disabled"></el-input>
                  </el-form-item>
                
                  <el-form-item label="商户号" :label-width="DLabelwidth" prop="subAccountKf">
                      <div v-if="orgForm.thirdPartyType == 1 && orgForm.fastMsg == '外部商户号已存在，不支持新增'">
                        <el-input v-model="orgForm.subAccountKf" placeholder="请输入商户号" :disabled="false"></el-input>
                      </div>
                      <div v-else>
                        <el-input v-model="orgForm.subAccountKf" placeholder="请输入商户号" :disabled="true"></el-input>
                      </div>
                  </el-form-item>
            </el-tab-pane>
            <el-tab-pane label="店铺信息" >
                   <el-form-item label="商户简称" prop="simpleName" :label-width="DLabelwidth">
                    <el-input  v-model="orgForm.simpleName" placeholder="请输入商户简称" :disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="门店名称" prop="storeName" :label-width="DLabelwidth">
                      <el-input v-model="storeForm.storeName" placeholder="请输入门店名称" :disabled="disabled" ></el-input>
                </el-form-item>
                <el-form-item label="商户邮箱" prop="serviceEmail" :label-width="DLabelwidth">
                      <el-input v-model="orgForm.serviceEmail" placeholder="请输入商户邮箱" :disabled="disabled"></el-input>
                </el-form-item>
                <el-form-item label="门店LOGO" prop="productPic" :label-width="DLabelwidth">
                    <template >
                    <el-upload style="width: 200px" class="avatar-uploader" action="" :show-file-list="false" :http-request="createBusinessLicenseHandler(1)" :disabled="disabled" >
                        <img v-if="storeForm.storeLogo" :src="storeForm.storeLogo" class="avatar" size="small" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <el-button v-if="storeForm.storeLogo" @click="handlePictureCardPreview(storeForm.storeLogo)" type="primary">查看</el-button>
                    </template>
                </el-form-item>
                <el-form-item label="门店门头" prop="storeBanner" :label-width="DLabelwidth">
                      <template >
                      <el-upload style="width: 200px" class="avatar-uploader" action="" :show-file-list="false" :http-request="createBusinessLicenseHandler(2)" :disabled="disabled" >
                          <img v-if="storeForm.storeBanner" :src="storeForm.storeBanner" class="avatar" size="small" />
                          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                        <el-button v-if="storeForm.storeBanner" @click="handlePictureCardPreview(storeForm.storeBanner)" type="primary">查看</el-button>
                      </template>
               </el-form-item>
               <el-form-item label="收银台图" prop="storeInterior1" :label-width="DLabelwidth">
                      <template >
                      <el-upload style="width: 200px" class="avatar-uploader" action="" :show-file-list="false" :http-request="createBusinessLicenseHandler('收银台图')" :disabled="disabled" >
                          <img v-if="storeForm.storeInterior1" :src="storeForm.storeInterior1" class="avatar" size="small" />
                          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                      <el-button v-if="storeForm.storeInterior1" @click="handlePictureCardPreview(storeForm.storeInterior1)" type="primary">查看</el-button>
                      </template>
               </el-form-item>
               <el-form-item label="内景照片" prop="storeInterior2" :label-width="DLabelwidth">
                      <template >
                      <el-upload style="width: 200px" class="avatar-uploader" action="" :show-file-list="false" :http-request="createBusinessLicenseHandler('内景照片')" :disabled="disabled" >
                          <img v-if="storeForm.storeInterior2" :src="storeForm.storeInterior2" class="avatar" size="small" />
                          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                      <el-button v-if="storeForm.storeInterior2" @click="handlePictureCardPreview(storeForm.storeInterior2)" type="primary">查看</el-button>
                      </template>
               </el-form-item>
            </el-tab-pane>
         </el-tabs>
        </el-form>
            <div class="operation" v-if="!disabled">
                <div class="primary" @click="submitForm">确 定</div>
                <div class="danger" @click="closeDialog">取 消</div>
            </div>
        </el-dialog>
        <!-- mcc弹窗 -->
        <el-dialog
          title="mcc编码查询"
          :visible.sync="dialogMcc"
          width="80%"
          height="90%"
           :close-on-click-modal="false"
          >
           <mccCide ref="mccCode"  
                    :orgType="orgForm.orgType"
                     @radioThis="radioThis" 
                     :mccCodeName = "orgForm.mccCodeName"
                     ></mccCide>
        </el-dialog>
        <!-- 银行编码弹窗 -->
        <el-dialog
          title="银行名称查询"
          :visible.sync="dialogBank"
          width="80%"
          height="90%"
          :close-on-click-modal="false"
          >
           <bankCode ref="bankCode"  @radioThisBank="radioThisBank" :bankName="orgForm.bankName" ></bankCode> 
        </el-dialog>
        <!-- 银行编码弹窗 -->
         <el-dialog
          title="支行名称查询"
          :visible.sync="dialogsubbranch"
          width="80%"
          height="90%"
          :close-on-click-modal="false"
          >
           <subBranch ref="bankCode" @subBranchChange="subBranchChange"  :cityCode="orgForm.bankCityId" :provinceCode="orgForm.bankProvinceId" :bankBranchName="orgForm.bankSubbranch" ></subBranch> 
        </el-dialog>
        <!-- <el-dialog :visible.sync="dialogImage" width="50%" height="700px">
            <img  style="width: 80%;
                         height: 700px;
                          margin: auto;"  :src="dialogImageUrl" alt="">
            </el-dialog> -->
            <el-image 
              ref="images"
              style="width: 100px; height: 100px"
              :src="dialogImageUrl" 
               @click='handlePictureCardPreview(dialogImageUrl)'
              :preview-src-list="srcList">
            </el-image>
  </div>  
</template>

<script>
import { UPLOAD_PATH, SHOP, SHOP_SEARCH, BRAND, BRAND_SEARCH } from '@/utils/constant.js';
import { get, post, deleteFun, upload } from '@/utils/request.js';
import mccCide from './mccCode.vue'
import bankCode from './bankCode.vue'
import subBranch from './subBranch.vue'
import axios from 'axios';
export default {
  components: {
    mccCide,
    bankCode,
    subBranch
  },
  props:{
     drawer:{
        type:Boolean,
        default:true
     }, 
     title:{
        type:String,
        default:""
     },
     orgObj:{
        type:Object,
        default:()=>{}
     },
      storeObj:{
          type:Object,
          default:()=>{}
      },
      disabled:{
          type:Boolean,
          default:true
      },
  },
    data() {
        return {
           srcList: [''],
          DLabelwidth:"110px",
          loading: false,
          labelName: '',
          dialogMcc: false,
          dialogBank: false,
          dialogsubbranch: false,
          dialogImage:false,
          form:{},
              storeForm:{
                  storeName:"", //门店名称
                  storeLogo:"",//门店LOGO、门店门头、店内景图
                  storeBanner:"",//门店LOGO、门店门头、店内景图
                  storeInterior:"",//门店LOGO、门店门头、店内景图
                  provinceId:"", //所属门店省份 
                  cityId:"",///所属门店城市
                  areaId:"", //所属门店区县 
                  storeAddress:"", //详细地址
                  openStatus:"", //营业状态
                  storeInterior1: "",
                  storeInterior2: "",
                 
              },
              orgForm: {
                  thirdPartyType:"",
                  storeId:"", //门店ID
                  orgType:"", //组织类型：1小微 2企业 3个体 
                  mccCode:"", //MCC码
                  mccCodeName:"", //组织名称 
                  licensePic:"", //营业执照图片
                  licenseName:"", //营业执照名称
                  licenseNumber:"", //营业执照统一社会信用代码
                  licenseAddress:"", //营业执照注册地址
                  licenseIsPermanent:"", //营业执照是否长期有效：1是 0否 
                  licenseStartTime:"",//营业执照有效开始日期
                  licenseEndTime:"", //营业执照有效结束日期
                  licenseRange:"", //营业执照经营范围
                  personName:"", //法人姓名
                  personMobile:"", //法人手机号
                  personEmail:"", //法人邮箱
                  idCard:"", //法人身份证号
                  idCardIsPermanent:"", //法人身份证是否长期有效：1是 0否
                  idCardStartTime:"", //身份证有效限期起始日期
                  idCardEndTime:"", //身份证有效限期结束日期
                  idCardFacade:"", //身份证正面照
                  idCardBack:"", //身份证背面照
                  idCardAddress:"", //身份证地址
                  bankAccount:"", //银行账户号
                  bankHolder:"", //银行户主
                  bankMobile:"", //银行户主手机号
                  bankCardFacade:"", //银行卡正面照
                  bankCardBack:"", //银行卡背面照
                  bankName:"", //银行名称
                  bankCode:"", //银行编码
                  bankSubbranch:"", //银行开户支行名称
                  bankProvinceId:"", //开户省份
                  bankCityId:"", //开户城市
                  bankAreaId:"", //开户区县
                  alipayApplyQrcode: "", //支付宝申请二维码
                  wxpayApplyQrcode: "", //微信申请二维码
                  alipayConfirmQrcode: "", //支付宝法人确认二维码
                  wxpayConfirmQrcode: "", //微信法人确认二维码
                  simpleName: "", //商户简称
                  servicePhone: "", //客服电话
                  serviceEmail: "", //商户邮箱
                  subAccountKf: "", //快付商户号
                  fastMsg: "", //快付进件失败描述
                  registerIdKf: "", //快付申请单号
                  isUpdated:'', //是否推送 0:未推送 1:已推送
                  alipayStatusKf: '',//快付支付宝认证 1.已认证 0.未认证
                  wxpayStatusKf: '',//快付微信认证 1.已认证 0.未认证
                  licenseProvinceId :"",//营业执照所在省份
                  licenseCityId:"",//营业执照所在城市
                  licenseAreaId:"",//营业执照所在区县
              },
              alipayStatusKfList:[
                 {value:1,label:'已认证'},
                 {value:0,label:'未认证'},
              ],
              wxpayStatusKfList:[
                 {value:1,label:'已认证'},
                 {value:0,label:'未认证'},
              ],
              orgTypeList:[
                {value:1,label:'小微'},
                {value:2,label:'企业'},
                {value:3,label:'个体'},
              ],
          
              mccCodeList: [], //mcc编码列表
              licenseProvinceIdList:[], //执照省份列表
              licenseCityIdList:[], //执照城市列表
              licenseAreaIdList:[], //执照区县列表
              provinceIdName: '',
              cityIdName: '',
              areaIdName: '',
              bankProvinceIdList:[], //银行开户省份列表
              bankCityIdList:[], //银行开户城市列表
              bankAreaIdList:[], //银行开户区县列表
              rulesForm: {
                mccCodeName: [{ required: true, message: '请选择mcc编码', trigger: ['blur','change'] }],
                storeName: [{ required: true, message: '请输入门店名称', trigger: ['blur','change'] }],
                storeLogo: [{ required: true, message: '请上传门店LOGO', trigger: ['blur','change'] }],
                storeBanner: [{ required: true, message: '请上传门店门头', trigger: ['blur','change'] }],
                storeInterior1: [{ required: true, message: '请上传收银台照片', trigger: ['blur','change'] }],
                storeInterior2: [{ required: true, message: '请上传店内照片', trigger: ['blur','change'] }],
                // provinceId: [{ required: true, message: '请选择所属门店省份', trigger: ['blur','change'] }],
                // cityId: [{ required: true, message: '请选择所属门店市', trigger: ['blur','change'] }],
                // areaId: [{ required: true, message: '请选择所属门店区', trigger: ['blur','change'] }],
                storeAddress: [{ required: true, message: '请输入详细地址', trigger: ['blur','change'] }],
                orgType: [{ required: true, message: '请选择组织类型', trigger: ['blur','change'] }],
                mccCode: [{ required: true, message: '请选择mcc编码', trigger: ['blur','change'] }],
                licenseName: [{ required: true, message: '请输入营业执照名称', trigger: ['blur','change'] }],
                licenseNumber: [{ required: true, message: '请输入统一社会信用代码', trigger: ['blur','change'] }],
                licenseAddress: [{ required: true, message: '请输入营业执照注册地址', trigger: ['blur','change'] }],
                idCardIsPermanent: [{ required: true, message: '请输入身份证是否长期有效', trigger: ['blur','change'] }],
                licenseIsPermanent: [{ required: true, message: '请输入营业执照是否长期有效', trigger: ['blur','change'] }],
                licenseStartTime: [{ required: true, message: '请选择营业执照有效期开始时间', trigger:['blur','change'] }],
                licenseEndTime: [{ required: true, message: '请选择营业执照有效期结束时间', trigger: ['blur','change'] }],
                licenseRange: [{ required: true, message: '请输入经营范围', trigger: ['blur','change'] }],
                personName: [{ required: true, message: '请输入法人姓名', trigger: ['blur','change'] }],
                personMobile: [{ required: true, message: '请输入法人手机号', trigger: ['blur','change'] },{ pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message: '请输入正确的手机号', trigger: ['blur','change'] }],
                personEmail: [{ required: true, message: '请输入法人邮箱', trigger: ['blur','change'] },{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur','change'] }],
                idCard: [{ required: true, message: '请输入法人身份证号', trigger: ['blur','change'] }],
                idCardStartTime: [{ required: true, message: '请选择身份证件有效期起始时间', trigger: ['blur','change']}],
                idCardEndTime: [{ required: true, message: '请选择身份证件有效期结束时间', trigger: ['blur','change']}],
                idCardFacade: [{ required: true, message: '请上传身份证正面照', trigger:['blur','change']}],
                idCardBack: [{ required: true, message: '请上传身份证反面照', trigger: ['blur','change'] }],
                  licensePic: [{ required: true, message: '营业执照图片不能为空', trigger: 'blur' }],
                businessLicense: [{ required: true, message: '请上传照片', trigger:['blur','change']}],
                bankAccount: [{ required: true, message: '请输入银行账户号', trigger: ['blur','change'] }],  
                bankHolder: [{ required: true, message: '请输入银行户主', trigger: ['blur','change'] }],
                bankMobile: [{ required: true, message: '请输入银行户主手机号', trigger: ['blur','change'] },{ pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message: '请输入正确的手机号', trigger: ['blur','change'] }],
                bankCardFacade: [{ required: true, message: '请上传银行卡正面照  ', trigger: ['blur','change']}],
                bankCardBack: [{ required: true, message: '请上传银行卡反面照', trigger: ['blur','change'] }],
                bankName: [{ required: true, message: '请选择银行名称', trigger: ['blur','change'] }], 
                bankSubbranch: [{ required: true, message: '请输入开户支行名称', trigger: ['blur','change']}],
                bankprovinceId: [{ required: true, message: '请选择开户所在省份', trigger: ['blur','change']}],
                bankprovinceIdList: [{ required: true, message: '请选择开户所在省份', trigger: ['blur','change']}],
                bankCityId: [{ required: true, message: '请选择开户所在城市', trigger: ['blur','change'] }],
                bankAreaId: [{ required: true, message: '请选择开户所在区', trigger: ['blur','change'] }],
                simpleName: [{ required: true, message: '请输入5-10个字的商户简称', trigger: ['blur','change'] },{ min: 5, max: 10, message: '请输入5-10个字的商户简称', trigger: 'blur' }],
                serviceEmail:[{ required: true, message: '请输入邮箱', trigger: ['blur','change'] },{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur','change'] }],
                licenseProvinceId:[{ required: true, message: '请选择营业执照所在省', trigger: ['blur','change']}],
                licenseCityId:[{ required: true, message: '请选择营业执照所在市', trigger: ['blur','change']}],
                licenseAreaId:[{ required: true, message: '请选择营业执照所在区', trigger: ['blur','change']}],
                },
              dialogImageUrl: '',
               kfbankProvinceId:"", //开户省份
               kfbankCityId:"", //开户城市
               kfbankAreaId:"", //开户区县
               zzlicenseProvinceId :"",//营业执照所在省份
               zzlicenseCityId:"",//营业执照所在城市
               zzlicenseAreaId:"",//营业执照所在区县
               kfshow:false,
               zzshow:false
        };
    },
    computed: {
      drawerVisible: {
        get() {
          return this.drawer;
        },
        set(val) {
          this.$emit('updateDrawer', val);
        }
      }
    },
  watch: {
    storeObj(newnew, oldold) {
      this.storeForm = { ...newnew };
       if (this.storeForm.storeInterior) {
            const images = this.storeForm.storeInterior.split('|');
            this.$set(this.storeForm, 'storeInterior1', images[0] || '');
            this.$set(this.storeForm, 'storeInterior2', images[1] || '');
        }
    },
    orgObj(newnew, oldold){
       this.orgForm = { ...newnew };
    },

  },
    mounted() {
        this.storeForm = { ...this.storeObj };
        this.orgForm = { ...this.orgObj };
       if (this.storeForm.storeInterior) {
          const images = this.storeForm.storeInterior.split('|');
          this.$set(this.storeForm, 'storeInterior1', images[0] || '');
          this.$set(this.storeForm, 'storeInterior2', images[1] || '');
        }
        // this.initProvinceData();
        this.initProvinceDataYh();
        this.licenseList()
    },
    methods: {
      handlePictureCardPreview(url) {
            this.srcList = [''];
            this.imageSrc = url;
            this.srcList[0] = url;
            this.$refs.images.showViewer = true;
      },
      closeDialog(){
         this.$emit('updateDrawer', false);
      },
      // 初始化门店省份数据
      // initProvinceData() {
        
      //    if(this.storeForm.provinceId){
      //           this.huiXianRegion(this.storeForm.provinceId, 'province', 'store')
      //     }
      //     if(this.storeForm.cityId){
      //         this.huiXianRegion(this.storeForm.cityId, 'city', 'store')
      //     }
      //      if(this.storeForm.areaId){
      //         this.huiXianRegion(this.storeForm.areaId, 'area', 'store')
      //     }
      // },
    // 初始化银行开户省份数据
      initProvinceDataYh() {
        // 获取省份列表
        this.getAddressBank(1).then(() => {
          // 如果已有省份ID，获取对应的城市和区县信息并回显
          if (this.orgForm.bankProvinceId) {
            // 获取城市列表
            this.getAddressBank(2, this.orgForm.bankProvinceId).then(() => {
              // 如果已有城市ID，获取对应的区县信息
              if (this.orgForm.bankCityId) {
                this.getAddressBank(3, this.orgForm.bankCityId);
              }
            });
          }
        });
      },
       // 初始化执照省份数据
      licenseList() {
        // 获取省份列表
        this.getAddressLicense(1).then(() => {
          // 如果已有省份ID，获取对应的城市和区县信息并回显
          if (this.orgForm.licenseProvinceId) {
            // 获取城市列表
            this.getAddressLicense(2, this.orgForm.licenseProvinceId).then(() => {
              // 如果已有城市ID，获取对应的区县信息
              if (this.orgForm.licenseCityId) {
                this.getAddressLicense(3, this.orgForm.licenseCityId);
              }
            });
          }
        });
      },
      // 获取对应地址 - 开户银行
      getAddressBank(type, id=null) {
        return get("/mpp/utils/findAreaList",{areaType:type,pid:id}).then((res)=>{
          if(res.success){
            let array = []
            for (let listElement of res.list) {
              listElement.id = String(listElement.id)
              array.push(listElement)
            }
            if(type == 1){
              this.bankProvinceIdList = array
            }else if(type == 2){
              this.bankCityIdList = array
            }else if(type == 3){
              this.bankAreaIdList = array
            }
            return array;
          }
        })
      },

      // 获取对应地址 - 营业执照
      getAddressLicense(type, id=null) {
        return get("/mpp/utils/findAreaList",{areaType:type,pid:id}).then((res)=>{
          if(res.success){
            let array = []
            for (let listElement of res.list) {
              listElement.id = String(listElement.id)
              array.push(listElement)
            }
            if(type == 1){
              this.licenseProvinceIdList = array
            }else if(type == 2){
              this.licenseCityIdList = array
            }else if(type == 3){
              this.licenseAreaIdList = array
            }
            return array;
          }
        })
      },
      // 银行开户省份变化时触发
      handleProvinceChangeYh(val) {
        this.orgForm.bankCityId = '';
        this.orgForm.bankAreaId = '';
        this.bankCityIdList = [];
        this.bankAreaIdList = [];
        
        if (val) {
          // 根据选中的省份ID获取城市列表
          this.getAddressBank(2, val);
        }
      },
      
      // 银行开户城市变化时触发
      handleCityChangeYh(val) {
        this.orgForm.bankAreaId = '';
        this.bankAreaIdList = [];
        
        if (val) {
          // 根据选中的城市ID获取区县列表
          this.getAddressBank(3, val);
        }
      },
      // 执照省份变化时触发
      handlelicenseProvinceIdChange(val) {
        this.orgForm.licenseCityId = '';
        this.orgForm.licenseAreaId = '';
        this.licenseCityIdList = [];
        this.licenseAreaIdList = [];
        
        if (val) {
          // 根据选中的省份ID获取城市列表
          this.getAddressLicense(2, val);
        }
      },
      
      // 执照城市变化时触发
      handlelicenseCityChange(val) {
        this.orgForm.licenseAreaId = '';
        this.licenseAreaIdList = [];
        
        if (val) {
          // 根据选中的城市ID获取区县列表
          this.getAddressLicense(3, val);
        }
      },

      // 通用的回显方法，可以处理多个省市区参数
      huiXianRegion(code, type, formType = 'store') {
          
          // 如果没有传入code，则直接返回
          if (!code) {
              return Promise.resolve();
          }
          this.loading = true
          return get('/newFastPay/transcodeQuery', {code: code}).then((res) => { 
              if(res.code == 200) { 
                this.loading = false
                  // if (formType == 'store') {
                  //   switch(type) {
                  //     case 'province':
                  //             this.storeForm.provinceId = res.data.fastPayCode;
                  //             this.provinceIdName = res.data.name;
                            
                  //             break;
                  //         case 'city':
                  //             this.storeForm.cityId = res.data.fastPayCode;
                  //             this.cityIdName = res.data.name;
                  //             break;
                  //         case 'area':
                  //             this.storeForm.areaId = res.data.fastPayCode;
                  //             this.areaIdName = res.data.name;
                  //             break;
                  //         default:
                  //             break;
                  //     }
                  // } 
                  if (formType == 'bank') {
                      switch(type) {
                          case 'province':
                              this.orgForm.bankProvinceId = res.data.fastPayCode;
                              this.kfbankProvinceId = res.data.tianyiCode
                              break;
                          case 'city':
                              this.orgForm.bankCityId = res.data.fastPayCode;
                              this.kfbankCityId = res.data.tianyiCode;
                              break;
                          case 'area':
                              this.orgForm.bankAreaId = res.data.fastPayCode;
                              this.kfbankAreaId = res.data.tianyiCode;
                              break;
                          default:
                              break;
                      }
                  }else if (formType == 'license') {
                      switch(type) {
                          case 'province':
                              this.orgForm.licenseProvinceId = res.data.fastPayCode;
                              this.zzlicenseProvinceId = res.data.tianyiCode
                              break;
                          case 'city':
                              this.orgForm.licenseCityId = res.data.fastPayCode;
                              this.zzlicenseCityId = res.data.tianyiCode
                              break;
                          case 'area':
                              this.orgForm.licenseAreaId = res.data.fastPayCode;
                              this.zzlicenseAreaId = res.data.tianyiCode
                              break;
                          default:
                              break;
                      }
                     
                  }
                 
              }
          });
      },
      
   
      

      
     handleClose(done) {
         done();
      },
            // 上传图片
   createBusinessLicenseHandler(type) {
                return (params) => {
                    this.businessLicense(params, type);
                };
            },
              // 上传图片
   businessLicense(params, type){
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
                if (!types.includes(file.type)) {
                    this.$message.error('图片类型错误!');
                }
                const formData = new FormData();
                formData.append('file', file);
                upload(UPLOAD_PATH, formData).then((res) => {
                    if (res.success) {
                        switch(type) {
                            case 1:
                                this.storeForm.storeLogo = res.url;
                                break;
                            case 2:
                               this.storeForm.storeBanner = res.url;
                                break;
                            case "收银台图":
                                this.storeForm.storeInterior1 = res.url;
                                break;
                            case "内景照片":
                                this.storeForm.storeInterior2 = res.url;
                                break;
                            case 4:
                                this.orgForm.licensePic = res.url;
                                break;
                            case 5:
                                this.orgForm.idCardFacade = res.url;
                                break;
                            case 6:
                                this.orgForm.idCardBack = res.url;
                                break;
                            case 7:
                                this.orgForm.bankCardFacade = res.url;
                                break;
                            case 8:
                                this.orgForm.bankCardBack = res.url;
                                break;
                            default:
                                break;
                        }
                    }
                });
            },
            orgTypeChange(row){
                this.orgForm.orgType = row.value;
            },
            // mcc编码返回值
            radioThis(item,show){
                this.dialogMcc = show
                this.orgForm.mccCode = item.mccCode
                this.orgForm.mccCodeName = item.mccName
            },
            // 银行编码返回值
            radioThisBank(item,show){
                this.dialogBank = show
                // this.orgForm.bankCode = item.bankCode
                this.orgForm.bankName = item.bankName

            },
            // 支行编码返回值
            subBranchChange(item,show){
               this.orgForm.bankSubbranch = item.bankBranchName
               this.orgForm.bankCode = item.bankBranchCode
               this.dialogsubbranch = show

            },
        // mcc编码
            getMccCode(){
               this.dialogMcc = true;
            },
            getBank(){
                this.dialogBank = true;
            },
            getSubbranch(){
                 this.dialogsubbranch = true;
            },
         
            
            // 修改
            submitForm(){
                console.log(this.orgForm);
                console.log(this.storeForm);
                // 是否长经营期 1是 0否
                if(this.orgForm.licenseIsPermanent == 1 && !this.orgForm.licenseEndTime ){
                     this.orgForm.licenseEndTime = "9999-12-31"
                }else{
                    this.orgForm.licenseEndTime = this.orgForm.licenseEndTime
                }
                if(this.orgForm.idCardIsPermanent == 1 && !this.orgForm.idCardEndTime ){
                  this.orgForm.idCardEndTime = "9999-12-31"
                }else{
                  this.orgForm.idCardEndTime = this.orgForm.idCardEndTime
                }
                this.storeForm.storeInterior = this.storeForm.storeInterior1 + '|' + this.storeForm.storeInterior2
                this.$refs.form.validate(valid => { 
                    if(valid){
                        axios({
                              method: 'post',
                              url: '/shop/store/updateByStoreId',
                              data: {
                                 org:{...this.orgForm},
                                 store:{...this.storeForm},
                              },
                          }).then(res => {
                             if(res.data.success){
                               this.$message({
                                    message: res.data.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                               this.closeDialog();
                             }else{
                               this.$message({
                                    message: res.data.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                             }
                               
                          }) 
                    }else{
                        this.$message({
                            message: '请填写必填项',
                            type: 'error',
                            duration: 2000
                        });
                        return false;
                    }
                });
              
            }
        },
        
};
</script>

<style lang="scss" scoped>
.form_item{
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: wrap   !important;
    justify-content: flex-start !important;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}


::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 30px;
    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }
    .primary{
        background-color: #409eff;
        color: #fff;
        border-radius: 4px;
        margin-right: 10px;
        width: 200px;
        height: 35px;
        margin-bottom: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .danger{
        width: 200px;
        background-color: #f56c6c;
        color: #fff;
        border-radius: 4px;
        height: 35px;
        margin-bottom: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.logo-img {
    margin-left: 50%;
    transform: translate(-50%, 0);
}
.count{
    margin-right:1.5625vw;
}
::v-deep .el-drawer__open .el-drawer.rtl{
   width: 40% !important;
}
::v-deep .el-input--small .el-input__inner{
   width: 200px !important;
}
</style>
